import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import { Button, Modal } from "react-bootstrap";
import { getAllUserData, getUserBydelete } from "../../api";
import { useSelector } from "react-redux";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import { Toast } from "primereact/toast";
import TableComponent from "../common/TableComponent";
import moment from "moment";

const UserManagement = () => {
  const { token } = useSelector((state) => state.profileReducer);
  const [allUserData, setAllUserData] = useState([]);
  const [allFilterData, setAllFilterData] = useState([]);
  const [show, setShow] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [showbanner, setShowBanner] = useState(true);

  const [isLoading, setIsLoading] = useState(false);

  const toast = useRef(null);

  const tableColumnTitles = [
    {
      name: "Full Name",
      field: "Full Name",
      isSortFilter: true,
      isAction: false,
    },
    { name: "Gender", field: "Gender", isSortFilter: true, isAction: false },
    {
      name: "User Type",
      field: "User Type",
      isSortFilter: true,
      isAction: false,
    },
    {
      name: "Country/City",
      field: "Country/City",
      isSortFilter: true,
      isAction: false,
    },
    {
      name: "Speciality",
      field: "Speciality",
      isSortFilter: true,
      isAction: false,
    },
    {
      name: "Super-Looper",
      field: "Super-Looper",
      isSortFilter: true,
      isAction: false,
    },
    {
      name: "Hall-Of-Fame",
      field: "Hall-Of-Fame",
      isSortFilter: true,
      isAction: false,
    },
    {
      name: "Voice Type",
      field: "Voice Type",
      isSortFilter: true,
      isAction: false,
    },
    { name: "Action", isSortFilter: false, isAction: true },
  ];

  const getUserDataFromAPI = async () => {
    setIsLoading(true);
    getAllUserData(token)
      .then((res) => {
        for (let records in res?.data?.result?.data) {
          const date = res.data.result.data[records].super_looper_createdAt;
          if (res.data.result.data[records].super_looper && date) {
            const local = moment.utc(date).local().format("MM");
            const current_date = moment().format("MM");
            if (local === current_date) {
              setShowBanner(false);
              break;
            }
          }
        }
        setIsLoading(false);
        setAllUserData(res?.data?.result?.data);
        setAllFilterData(res?.data?.result?.data);
      })
      .catch((err) => {
        setIsLoading(false);
      });
  };

  // Filtering

  const updateResponseData = (searchData) => {
    searchData.map((ele) => {
      if (ele.searchField !== "") {
        if (ele?.searchValue !== "") {
          switch (ele.searchField) {
            case "Full Name":
              const dataUser = allFilterData.filter((item) => {
                const regx = new RegExp(`${ele.searchValue.toLowerCase()}`);
                const fullName =
                  item?.first_name.trim().toLowerCase() +
                  " " +
                  item?.last_name.trim().toLowerCase();
                return regx.test(fullName);
              });
              setAllUserData(dataUser);
              break;
            case "Gender":
              const dataGender = allFilterData.filter((item) => {
                const name = ele.searchValue.toLowerCase();
                // const nonname = ele.searchValue.toLowerCase();
                const fname = ele.searchValue.toLowerCase();
                const startsWithM = name.startsWith("m");
                // const startsWithNon = nonname.startsWith("non");
                const startsWithF = fname.startsWith("f");

                if (startsWithM) {
                  return item.gender === "1"; // Filter for gender 1 if the name starts with 'M' or 'm'
                } else if (startsWithF) {
                  return item.gender === "2"; // Filter for gender 2 if the name starts with f'
                } else {
                  return item.gender === "3"; // Filter for gender 3 non-binary
                }
              });
              setAllUserData(dataGender);
              break;
            case "User Type":
              const dataUserType = allFilterData.filter((item) => {
                const uname = ele.searchValue.toLowerCase();
                const aname = ele.searchValue.toLowerCase();
                const ambname = ele.searchValue.toLowerCase();
                const startsWithU = uname.startsWith("u");
                const startsWithAdm = aname.startsWith("adm");
                const startWithAmb = ambname.startsWith("amb");

                if (startsWithU) {
                  return item.role === "User"; // Filter for gender 1 if the name starts with 'M' or 'm'
                } else if (startsWithAdm) {
                  return item.role === "Admin"; // Filter for gender 2 if the name starts with f'
                } else if (startWithAmb) {
                  return item.role === "Ambassador"; // Filter for gender 3 non-binary
                } else {
                  return item.role;
                }
              });
              setAllUserData(dataUserType);
              break;
            case "Country/City":
              const dataConCit = allFilterData.filter(
                (item) =>
                  item?.country
                    ?.toLowerCase()
                    .includes(ele.searchValue.toLowerCase()) ||
                  item?.city
                    ?.toLowerCase()
                    .includes(ele.searchValue.toLowerCase())
              );
              setAllUserData(dataConCit);
              break;
            case "Speciality":
              const dataSpeciality = allFilterData.filter((item) =>
                getSpecialties(item?.specialties || [])
                  ?.toLowerCase()
                  ?.includes(ele.searchValue.toLowerCase())
              );
              setAllUserData(dataSpeciality);
              break;
            case "Super-Looper":
              const datasuperlooper = allFilterData.filter((item) => {
                const tname = ele.searchValue.toLowerCase();
                const startsWithT = tname.startsWith("yes");

                if (startsWithT) {
                  return item.super_looper === true;
                } else {
                  return item.super_looper === false;
                }
              });
              setAllUserData(datasuperlooper);
              break;
            case "Hall-Of-Fame":
              const datahalloffame = allFilterData.filter((item) => {
                const tname = ele.searchValue.toLowerCase();
                const startsWithT = tname.startsWith("yes");

                if (startsWithT) {
                  return item.hall_of_fame === true;
                } else {
                  return item.hall_of_fame === false;
                }
              });
              setAllUserData(datahalloffame);
              break;
            case "Voice Type":
              const dataVoice_Type = allFilterData.filter((item) =>
                getVoiceType(item?.voice_types)
                  ?.toLowerCase()
                  ?.includes(ele.searchValue.toLowerCase())
              );
              setAllUserData(dataVoice_Type);
              break;

            default:
              break;
          }
        } else {
          setAllUserData(allFilterData);
        }
      }
      return "";
    });
  };

  useEffect(() => {
    async function getAllAPI() {
      await getUserDataFromAPI();
    }
    getAllAPI();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getVoiceType = (arr) => {
    if (arr && arr.length !== 0) {
      let voice = arr.map((e) => e.name_en);
      return voice.toString();
    }
    return "-";
  };

  const getSpecialties = (specialityArr) => {
    if (!Array.isArray(specialityArr)) {
      specialityArr = [];
    }
    if (specialityArr && specialityArr.length !== 0) {
      let speciality = specialityArr?.map((e) => e.name_en);
      return speciality?.toString();
    }
    return "-";
  };

  const deleteUser = (id) => {
    setIsLoading(true);
    setShow(false);
    getUserBydelete(id, token)
      .then((res) => {
        setIsLoading(false);
        toast.current.show({
          severity: "success",
          summary: `${res?.data?.message}`,
        });
        setTimeout(async () => {
          getUserDataFromAPI();
        }, 10000);
      })
      .catch((err) => {
        setIsLoading(false);
        toast.current.show({
          severity: "err",
          summary: `${err?.data?.message}`,
        });
      });
  };

  const adminTableRequests = (ele, index) => {
    return (
      <>
        <tr key={index} className="table-light">
          <td>
            <div className="image d-flex align-items-center">
              <img
                alt="Thumbnail"
                className="img-circle elevation-2 profile-img"
                src={
                  ele?.profile_pic
                    ? ele?.profile_pic
                    : require("../../assets/defaultImg.png")
                }
              />
              <h6 className="mb-0 ms-3">
                {ele?.first_name ? ele?.first_name : " - "}{" "}
                {ele?.last_name ? ele?.last_name : "-"}
              </h6>
            </div>
          </td>
          <td>
            {ele?.gender === "1"
              ? "male"
              : ele?.gender === "2"
              ? "female"
              : ele?.gender === "3"
              ? "Non-Binary"
              : "-"}
          </td>
          <td>{ele?.role ? ele?.role : "-"}</td>
          <td>
            {ele?.country ? ele?.country + " ," : " - "}{" "}
            {ele?.city ? ele?.city : "-"}
          </td>
          <td className="both-specialities-voice">
            {getSpecialties(ele?.specialties)}
          </td>
          <td> {ele?.super_looper ? "Yes" : "No"}</td>
          <td>{ele?.hall_of_fame ? "Yes" : "No"}</td>
          <td className="both-specialities-voice">
            {getVoiceType(ele?.voice_types)}
          </td>
          <td className="right-side-add-all-portion">
            <div className="usermng-flexs row">
              <div className="col-lg-4 px-0">
                {ele.isApprove && (
                  <svg
                    fill="#00FF00"
                    version="1.1"
                    id="Capa_1"
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 335.765 335.765"
                    className="me-2 cursor-pointer"
                  >
                    <g>
                      <g>
                        <polygon points="311.757,41.803 107.573,245.96 23.986,162.364 0,186.393 107.573,293.962 335.765,65.795 		" />
                      </g>
                    </g>
                  </svg>
                )}
              </div>
              <div className="col-lg-4 px-0">
                <Link
                  to={{
                    pathname: "/user-management/profile",
                    search: `?userId=${ele.id}`,
                  }}
                  aria-expanded="false"
                  data-toggle="collapse"
                  className="action-link "
                >
                  <svg
                    width="20"
                    height="14"
                    viewBox="0 0 20 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="me-2"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M19.3377 6.7875C17.8352 2.90106 14.164 0.28158 10.0002 0.125C5.83641 0.28158 2.1652 2.90106 0.662722 6.7875C0.613077 6.92482 0.613077 7.07518 0.662722 7.2125C2.1652 11.0989 5.83641 13.7184 10.0002 13.875C14.164 13.7184 17.8352 11.0989 19.3377 7.2125C19.3874 7.07518 19.3874 6.92482 19.3377 6.7875ZM6.25 7C6.25 4.92893 7.92893 3.25 10 3.25C12.0711 3.25 13.75 4.92893 13.75 7C13.75 9.07107 12.0711 10.75 10 10.75C7.92893 10.75 6.25 9.07107 6.25 7ZM7.5 7C7.5 8.38071 8.61929 9.5 10 9.5C10.663 9.5 11.2989 9.23661 11.7678 8.76777C12.2366 8.29893 12.5 7.66304 12.5 7C12.5 5.61929 11.3807 4.5 10 4.5C8.61929 4.5 7.5 5.61929 7.5 7ZM1.91897 7C3.18772 10.1687 6.68772 12.625 10.0002 12.625C13.3127 12.625 16.8127 10.1687 18.0815 7C16.8127 3.83125 13.3127 1.375 10.0002 1.375C6.68772 1.375 3.18772 3.83125 1.91897 7Z"
                      fill="black"
                    />
                  </svg>
                </Link>
              </div>
              <div className="col-lg-4 px-0">
                <Link
                  aria-expanded="false"
                  data-toggle="collapse"
                  className="action-link "
                  // onClick={() => deleteUser(ele.id)}
                  onClick={() => {
                    setDeleteId(ele.id);
                    setShow(true);
                  }}
                >
                  <svg
                    width="16"
                    height="18"
                    viewBox="0 0 16 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M10.5 0.25H5.5V1.5H10.5V0.25ZM0.5 2.75V4H1.75V16.5C1.75 17.1904 2.30964 17.75 3 17.75H13C13.6904 17.75 14.25 17.1904 14.25 16.5V4H15.5V2.75H0.5ZM3 16.5V4H13V16.5H3ZM5.5 6.5H6.75V14H5.5V6.5ZM10.5 6.5H9.25V14H10.5V6.5Z"
                      fill="#212121"
                    />
                  </svg>
                </Link>
              </div>
            </div>
          </td>
        </tr>
      </>
    );
  };

  return (
    <>
      <Toast ref={toast} />
      {isLoading && (
        <div className="set-proper-line-in-all-page">
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      )}
      {show && (
        <Modal
          show={show}
          onHide={() => setShow(false)}
          className="logout-modal"
          centered
        >
          <Modal.Header closeButton></Modal.Header>
          <Modal.Body className="modal-title text-center">
            Are you sure you want to delete this user?
          </Modal.Body>
          <Modal.Footer className="border-0 justify-content-center">
            <Button
              variant="secondary"
              className="me-3 yes-btn-cls-add"
              onClick={() => {
                deleteUser(deleteId);
                getUserDataFromAPI();
              }}
            >
              Yes
            </Button>
            <Button
              variant="secondary"
              className="no-btn-cls-add"
              onClick={() => {
                setDeleteId(null);
                setShow(false);
              }}
            >
              No
            </Button>
          </Modal.Footer>
        </Modal>
      )}
      <div className="content-section">
        <div className="card main-user-card">
          <div className="row m-0">
            <div className="mt-4 p-0 mr-2 d-flex justify-content-between align-items-center mu-less-up-side">
              <div className="title-heading">User Management</div>
              <div className="right_section_action">
                <Link to="/user-management/addUser">
                  <button className="btn fill_btn float-right apply-btn-cls">
                    Add User
                  </button>
                </Link>
              </div>
            </div>
            {showbanner ? (
              <h3 className="blink">
                Alert! The selection of 'SuperLooper' is still pending for this
                month.
              </h3>
            ) : (
              ""
            )}
          </div>
          <TableComponent
            tableColumnTitles={tableColumnTitles}
            tabRequests={allUserData}
            tableRowRequests={adminTableRequests}
            updateResponseData={updateResponseData}
            // updateSortingResponseData={updateSortingResponseData}
          />
        </div>
      </div>
    </>
  );
};

export default UserManagement;
